import { State, selectAppPreview } from '../../index'

export const selectReviewTextImage = (state: State) => selectAppPreview(state).reviewTextImage
export const selectReviewTextImageFirstStepData = (state: State) => selectReviewTextImage(state).step1
export const selectReviewTextImageInterpolationListData = (state: State) =>
    selectReviewTextImage(state).interpolationListData
